import React from 'react';
import { useWatch } from '../../contexts/WatchContext';
import Screens from './Screens';

const WatchedScreens = () => {
  const { isWatching, watchedUser, stopWatching } = useWatch();

  // If not watching, redirect to regular screens page
  if (!isWatching || !watchedUser) {
    return <Screens />;
  }

  return (
    <div className="relative">
      {/* Watched User Banner */}
      <div className="mb-6 p-4 bg-orange-50 border border-orange-200 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-sm">👁</span>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-orange-800">
                Watching User: {watchedUser.displayNameOrEmail}
              </h3>
              <p className="text-sm text-orange-600">
                You are viewing and managing this user's screens. All changes will affect their account.
              </p>
            </div>
          </div>
          <button
            onClick={stopWatching}
            className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          >
            Stop Watching
          </button>
        </div>
      </div>

      {/* Render the regular Screens component */}
      <Screens />
    </div>
  );
};

export default WatchedScreens; 